import * as React from 'react';
import { useMortgage } from './hooks/useMortgage';
import { MortgageMobile, MortgageFields, MortgageProgramCarousel } from '../../components/Mortgage';
import { MortgageProgramModalMobile } from '../../components/Mortgage/components/MortgageProgramModal';
import { calculateMonthlyPayment } from './utils/calculateMonthlyPayment';

export const MortgageContainerMobile: React.FC = () => {
  const {
    programs,
    fields,
    selectedProgram,
    selectProgram,
    resetSelectedProgram,
    trackMortgageModalButtonClick,
    trackMortgageButtonClick,
  } = useMortgage();

  const { price, initialPayment, paymentPeriod, minRate } = fields;

  const minPayment = React.useMemo(
    () => calculateMonthlyPayment({ price, initialPayment, years: paymentPeriod, rate: minRate }),
    [initialPayment, minRate, paymentPeriod, price],
  );

  return (
    <>
      <MortgageMobile
        fields={<MortgageFields {...fields} />}
        minRate={minRate}
        minPayment={minPayment}
        programs={<MortgageProgramCarousel items={programs} onProgramSelect={selectProgram} />}
        onMortgageButtonClick={trackMortgageButtonClick}
      />
      {selectedProgram && (
        <MortgageProgramModalMobile
          onClose={resetSelectedProgram}
          onMortgageButtonClick={trackMortgageModalButtonClick}
          {...selectedProgram}
        />
      )}
    </>
  );
};
